import { createContext, useCallback, useContext, useMemo, useState, type ReactNode } from "react";

type IPFilterContextValue = {
  query: string;
  setQuery: (q: string) => void;
};

const IPFilterContext = createContext<IPFilterContextValue | null>(null);

export function IPFilterProvider({ children }: { children: ReactNode }) {
  const [query, setQueryState] = useState("");
  const setQuery = useCallback((q: string) => {
    setQueryState(q);
  }, []);
  const value = useMemo(() => ({ query, setQuery }), [query, setQuery]);
  return <IPFilterContext.Provider value={value}>{children}</IPFilterContext.Provider>;
}

export function useIPFilter(): IPFilterContextValue {
  const ctx = useContext(IPFilterContext);
  if (!ctx) throw new Error("useIPFilter must be used within IPFilterProvider");
  return ctx;
}
